import { useAppSelector } from '@verantos-dev/app-state-base';
import {
  selectCohortDefinitionIsEditable,
  selectCohortDefinitionIsVersionLoading,
  selectCohortProfileIsLoading,
} from '@verantos-dev/app-state-cohort-definition';

export const useCohortEditable = () => {
  const isEditable = useAppSelector(selectCohortDefinitionIsEditable);
  const isCohortProfileLoading = useAppSelector(selectCohortProfileIsLoading);
  const isCohortVersionLoading = useAppSelector(selectCohortDefinitionIsVersionLoading);
  return {
    isEditable,
    isCohortProfileLoading,
    isCohortVersionLoading,
  };
};
